import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getAnalyticsIds, pushToDataLayer } from '@/utils/gtm';

export const useGA4PageView = () => {
  const router = useRouter();

  useEffect(() => {
    const firePageView = () => {
      pushToDataLayer({ page_location: window.location.href, event: 'page_view', ...getAnalyticsIds() });
    };

    firePageView();

    router.events.on('routeChangeComplete', firePageView);
    return () => {
      router.events.off('routeChangeComplete', firePageView);
    };
  }, [router.events]);
};
